import React, { useEffect, useState } from 'react'
import ReactImageFallback from 'react-image-fallback';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import Loader from './Loader.component';

import defaultUser from "../assets/images/default_profile_pic.jpg";
import moment from 'moment';
import Stars from './Utilities/Stars.component';

export default function UserReviews(props) {

    // console.log(props.userID);
    // console.log(props.role);
    const [reviews, setReviews] = useState("");

    const token = useSelector(state => state.auth.token);

    const getUserReviews = async () => {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/reviews?receiver_id=${props.userID}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(r => r.json())
        .then(response => {
            if(response.success && response.records.data.length > 0){
                setReviews(response);
            } else {
                console.log(response);
            }
        })
    };

    useEffect(() => {
        getUserReviews();
    }, []);

    return (
        <>
            
                <div className="bds-box">
                    <div className="bds-sectiontitle">
                        <div className="bds-featureRating">
                            <h3>{reviews?.total} Reviews</h3>                        
                        </div>
                    </div>
                    <div className="bds-reviews">
                        <div className="bds-reviews_holder">
                            
                            {
                                reviews ? reviews.records.data[0].receiver_id == props?.userID &&
                                reviews.records.data && reviews.records.data.map(item => 
                                    <div className="bds-reviews-box w-100">
                                        <div className="bds-reviews-img">
                                            <figure>
                                                <ReactImageFallback 
                                                    src={`${process.env.REACT_APP_BASE_URL}/public/storage/${item?.sender_details?.profile_image}`}
                                                    initialImage={defaultUser}
                                                    fallbackImage={defaultUser}
                                                    width={70} 
                                                    height={70} 
                                                    alt="Image Description" 
                                                />
                                            </figure>
                                            <div className="bds-featureRating bds-featureRatingv2 align-items-center">
                                                <Stars
                                                    showStars={item?.stars}
                                                />
                                                {/* <span className="bds-featureRating__stars"><span></span></span> */}
                                                <h6 className='mb-0 ms-2'>{item?.stars} Stars Review</h6>
                                            </div>
                                            <div className="bds-Reviews-detail">
                                                <span className="bds-review-time">{moment(item?.update_at).format("MMMM Do, YYYY")}</span>                                                
                                            </div>
                                        </div>
                                        <div className="bds-description">
                                            <p>
                                            {item?.description}
                                            </p>
                                        </div>
                                    </div> 
                                )
                                : <p className='text-center text-muted'>No Review Found</p>
                            }


                        </div>
                    </div>
                </div>
           
        </>
    )
}
